<div
  class="flex flex-col items-center gap-4 w-full"
  [ngClass]="{ 'pb-20': isOffLineMode() }"
  *transloco="let t; prefix: 'qrcode-module'"
>
  <div *ngIf="hasOfflineToggle()" class="flex flex-col gap-2">
    <div class="form-control">
      <label
        (click)="toggleOffLineMode($event)"
        class="label cursor-pointer items-center justify-center w-fit m-auto flex gap-2"
      >
        <span class="label-text text-xs text-neutral-400">{{
          t("offline_mode")
        }}</span>
        <input
          type="checkbox"
          class="toggle toggle-sm toggle-success"
          [checked]="isOffLineMode() ? 'checked' : ''"
        />
      </label>
    </div>
  </div>

  <div *ngIf="isOffLineMode()" class="bg-primary p-2 rounded-box">
    <h2 class="text-[1.3rem] text-white m-0 font-semibold text-center w-full">
      {{ trigger() }}
    </h2>
  </div>

  <div
    class="border-4 border-base-100 bg-white dark:border-none rounded-box w-auto"
  >
    <div #canvas id="canvas" class="w-auto flex flex-col items-center"></div>
  </div>

  <div *ngIf="!isOffLineMode()" class="flex flex-col flex-grow gap-2 w-full">
    <div class="flex w-full justify-center">
      <label
        *ngIf="!link()"
        class="input input-bordered !bg-base-100 rounded-box flex w-[310px] items-center gap-2 pr-0 relative z-10"
      >
        <input
          disabled
          type="text"
          class="grow"
          [value]="link() || paymentLink()"
        />
        <button
          class="btn btn-sm btn-primary dark:!text-white dark:border-white dark:hover:!bg-white dark:hover:!text-black rounded-box flex justify-center absolute right-2 z-20"
          (click)="copy()"
          [ngClass]="
            copying()
              ? '!btn-success !bg-success !text-white dark:md:!btn-success dark:hover:md:!btn-success dark:hover:md:!text-white !dark:!hover:md:!bg-success dark:border-none'
              : 'btn-outline bg-base-300'
          "
        >
          @if (copying()) {
            <span class=""> {{ t("copied") }} </span>
            <i class="fa-regular fa-check-circle text-lg"></i>
          } @else {
            <span class=""> {{ t("copy_link") }}</span>
            <i class="fa-regular fa-copy text-lg"></i>
          }
        </button>
      </label>
    </div>
    <div class="flex flex-grow gap-2 w-full max-w-[310px] m-auto items-center">
      <button
        *ngIf="!link()"
        class="btn btn-md btn-primary dark:!border-white dark:!text-white dark:hover:!bg-white dark:hover:!text-black rounded-box btn-outline flex flex-1 justify-center"
        (click)="share()"
      >
        <span class="mt-1"> {{ t("share_link") }} </span>
        <i class="fa-solid fa-share-all text-lg"></i>
      </button>

      @if (canDownload()) {
        <button
          class="btn btn-md btn-primary dark:!border-white dark:!text-white dark:hover:!bg-white dark:hover:!text-black rounded-box btn-outline flex flex-1 justify-center"
          (click)="download()"
        >
          <span class="mt-1"> {{ t("download") }} </span>
          <i class="fa-solid fa-download text-lg"></i>
        </button>
      }
    </div>
  </div>
</div>
